var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-container',{staticClass:"CustomMod"},[(_vm.loading)?_c('ui-loading'):_vm._e(),(_vm.modUrl)?_c('iframe',{ref:"window",attrs:{"src":_vm.modUrl}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }